export default {
    title: 'Edit company-micro-trend',
    success: 'Company-Micro-Trend "{title}" successfully saved'
}
